export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11969.21d99c83.jpg";